import type { BillingMode } from "../contracts/common";
import {
  EVENT_FEATURE_KEYS,
  EVENT_FEATURES_DEFAULT,
  EVENT_FEATURES_MANUAL_EVENT,
  EVENT_FEATURES_ORGANIZER_KOL_MEDIA,
  EVENT_FEATURES_PERFORMANCE_SHOW,
  EventFeaturesSchema,
  type EventFeatureKey,
  type EventFeaturePreset,
  type EventFeaturesDTO,
} from "../contracts/event-features";

export {
  EVENT_FEATURE_KEYS,
  EVENT_FEATURES_DEFAULT,
  EVENT_FEATURES_MANUAL_EVENT,
  EVENT_FEATURES_ORGANIZER_KOL_MEDIA,
  EVENT_FEATURES_PERFORMANCE_SHOW,
} from "../contracts/event-features";

export function eventFeaturesFromBillingMode(
  billingMode: BillingMode,
): EventFeaturesDTO {
  return billingMode === "manual"
    ? { ...EVENT_FEATURES_MANUAL_EVENT }
    : { ...EVENT_FEATURES_PERFORMANCE_SHOW };
}

export function eventFeaturesFromPreset(
  preset: EventFeaturePreset,
  custom?: Partial<EventFeaturesDTO>,
): EventFeaturesDTO {
  if (preset === "performance_show") {
    return { ...EVENT_FEATURES_PERFORMANCE_SHOW };
  }
  if (preset === "manual_event") {
    return { ...EVENT_FEATURES_MANUAL_EVENT };
  }
  if (preset === "organizer_kol_media") {
    return { ...EVENT_FEATURES_ORGANIZER_KOL_MEDIA };
  }
  return normalizeEventFeatures({
    ...EVENT_FEATURES_DEFAULT,
    ...custom,
  });
}

export function normalizeEventFeatures(
  input: Partial<EventFeaturesDTO> | null | undefined,
): EventFeaturesDTO {
  const base = { ...EVENT_FEATURES_DEFAULT, ...input };
  return EventFeaturesSchema.parse(base);
}

export function eventHasFeature(
  features: EventFeaturesDTO,
  key: EventFeatureKey,
): boolean {
  return features[key] === true;
}

/** Backward compat for reports still reading billing_mode */
export function deriveBillingModeCompat(
  features: EventFeaturesDTO,
): BillingMode {
  if (features.staff && !features.performers) {
    return "manual";
  }
  return "performance";
}

export function validateEventFeatures(features: EventFeaturesDTO): void {
  EventFeaturesSchema.parse(features);
  if (features.rehearsals && !features.performers) {
    throw new Error("EVENT_FEATURE_DEPENDENCY");
  }
}

export function detectEventFeaturePreset(
  features: EventFeaturesDTO,
): EventFeaturePreset {
  const perf = EVENT_FEATURES_PERFORMANCE_SHOW;
  const manual = EVENT_FEATURES_MANUAL_EVENT;
  if (EVENT_FEATURE_KEYS.every((key) => features[key] === perf[key])) {
    return "performance_show";
  }
  if (EVENT_FEATURE_KEYS.every((key) => features[key] === manual[key])) {
    return "manual_event";
  }
  const organizer = EVENT_FEATURES_ORGANIZER_KOL_MEDIA;
  if (EVENT_FEATURE_KEYS.every((key) => features[key] === organizer[key])) {
    return "organizer_kol_media";
  }
  return "custom";
}
